<template>
  <div>
    <div v-if="showPrompt" class="text-danger font-sm font-weight-bold mb-2" role="alert">
      Email address is not verified, please check your email or <button class="btn-link" @click="resendVerification()">click here to send another verification link</button>
    </div>
    <div v-if="showResponse" class="text-danger font-sm font-weight-bold mb-2" role="alert">
      {{ resendConfirmationResult.message ? resendConfirmationResult.message : "Sending..." }}
    </div>
  </div>
</template>
<script>
import CrypTools from '../../../../common/utils/CrypTools'

export default {
  props : {
    emailAddress : String
  },
  data(){
    return {
      showPrompt : false,
      showResponse : false,
    }
  },
  methods: {
    show(){
      this.showPrompt = true
    },
    clear(){
      this.showPrompt = false
      this.showResponse = false
    },
    resendVerification(){
      if(this.showPrompt && this.emailHash){
        this.$store.dispatch('resendConfirmationEmail', this.emailHash);
        this.showPrompt = false
        this.showResponse = true
      }
    },
    
  },
  computed: {
    emailHash(){
      if (this.emailAddress){
        var crypTools = new CrypTools
        return crypTools.stringToDouble64Hash(this.emailAddress)
      }
    },
  
    
    resendConfirmationResult(){
      return this.$store.getters.GET_RESEND_CONFIRMATION_EMAIL
    },
  }
}
</script>